export default "__VITE_ASSET__BctD$YdQ__"